import Commons from '../../../Services/Common/Common';

/**
 * 작업종료 작성 (M_WOE_BASIC_01) 요청 파라미터 매핑
 * 사용처: M_WOE_BASIC_01_Query.js (useSave1)
 */
export const WOE_BASIC_01_Schema = {
  /** 화면 폼 필드 정의 (initial, label, required, placeholder, maxLength) - createInitial / InputText schema 참조 */
  fields: {
    beforeComment: {
      initial: '',
      label: '내용',
      required: 'Y',
      placeholder: '내용을 입력하세요.',
      maxLength: 1000,
    },
  },

  mapper: {
    /** useSave1 → SaveWoeBasicU2 (작업종료 등록) SP_WOE_BASIC_U1 */
    save1: {
      WorkCd: (ctx) => Commons.EncryptAES(ctx?.workCd ?? '') || '',
      DepCd: (ctx) => Commons.EncryptAES(ctx?.depCd ?? '') || '',
      BeforeComment: (ctx) =>
        Commons.EncryptAES(ctx?.beforeComment ?? '') || '',
      BeforeImage: (ctx) =>
        Commons.EncryptAES(ctx?.beforeImage ?? '') || '',
      UserId: (ctx) => ctx.userInfo?.userid ?? '',
    },
  },
};
